var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-carousel',{staticStyle:{"width":"100%","margin-top":"80px"},attrs:{"height":"700px"}},_vm._l((_vm.carouselList),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{staticClass:"scoll-img",attrs:{"src":item.cover,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }